// extracted by mini-css-extract-plugin
export default {"confirmation":"Confirmation_confirmation__Aq1dR","buttonGrid":"Confirmation_buttonGrid__yPnzf"};